import { each, min, map } from 'lodash';
import {
  allPlansInclude, planFeatures,
  perkTitles, perkFeatures,
  perksSectionTitle, perksSectionText,
  linesEmptyPlanTitle
} from "../common/common_data";

const pricing = [
  [ 60, 60, 5, 5, 5 ],
  [ 75, 75, 20, 20, 20 ],
  [ 85, 85, 30, 30, 30 ]
];

const priceForLine = (planId, lineIndex) => {
  if (!planId) {
    return null;
  }
  return pricing[planId - 1][lineIndex];
};

const planA = {
  id: 1,
  name: "Plan A",
  features: [
    planFeatures.Unlimited5G
  ],
  perksCount: 0
};

const planB = {
  id: 2,
  name: "Plan B",
  features: [
    planFeatures.Unlimited5GUltra,
    planFeatures.Get800ToNewPhone,
    planFeatures.plusPerks(1)
  ],
  choosePerks: planFeatures.choosePerks(1),
  perksCount: 1
};

const planC = {
  id: 3,
  name: "Plan C",
  features: [
    planFeatures.Unlimited5GUltra,
    planFeatures.Get800ToNewPhone,
    planFeatures.plusPerks(2)
  ],
  choosePerks: planFeatures.choosePerks(2),
  perksCount: 2
};


const entertainmentPerk = {
  id: 1,
  list: [
    perkFeatures.DisneyBundle
  ]
};

const entertainmentStorePerk = {
  id: 2,
  list: [
    perkFeatures.EntertainmentStore
  ]
};

const musicPerk = {
  id: 3,
  list: [
    perkFeatures.AppleMusic
  ]
};

const gamingPerk = {
  id: 4,
  list: [
    perkFeatures.GameXBox,
    perkFeatures.GameArcade
  ]
};

const globalCallingPerk = {
  id: 5,
  list: [
    perkFeatures.GlobalCalling
  ]
};

const internationalRoamingPerk = {
  id: 6,
  list: [
    perkFeatures.Roaming
  ]
};

const workAnywherePerk = {
  id: 7,
  list: [
    perkFeatures.AnyWhereMobile,
    perkFeatures.AnyWhereWatch
  ]
};

const securityPerk = {
  id: 8,
  list: [
    perkFeatures.SecurityMCAfee,
    perkFeatures.SecurityRing,
    perkFeatures.SecurityVerizon
  ]
};

const homeInternetPerk = {
  id: 9,
  list: [
    perkFeatures.HomeInternet25
  ]
};

const plans = [ planA, planB, planC ];

const perkList = [
  entertainmentPerk,
  entertainmentStorePerk,
  musicPerk,
  gamingPerk,
  globalCallingPerk,
  internationalRoamingPerk,
  workAnywherePerk,
  securityPerk,
  homeInternetPerk
];
each(perkList, (item, index) => {
  item.title = perkTitles[index];
});

const cell2 = {
  plans,
  getPlanPriceByLine: (plan, currentLine) => (
    pricing[plan.id - 1][currentLine - 1]
  ),
  allPlansInclude, pricing,
  perks: perkList,
  perksSectionTitle,
  perksSectionText,
  specialPricingMinPricePerLine: map(pricing[0], (item, index) => (
    min(map(plans, (plan) => (pricing[plan.id - 1][index])))
  )),
  linesEmptyPlanTitle
};
cell2.linesDescriptionKlass = 'bolder';
cell2.linesDescription = `Third line starting as low as $${cell2.specialPricingMinPricePerLine[2]}/mo.`;

export { cell2, priceForLine  };
